<template>
  <div class="login-main">
    <div class="black-bg-box">
      <div class="title">小广告链接自助更换后台管理系统</div>
      <div class="login-form-box">
        <p>登录</p>
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-width="80px"
          class="login-from"
        >
          <el-form-item label="账号:" prop="username">
            <el-input v-model="form.username"></el-input>
          </el-form-item>
          <el-form-item label="密 码:" class="password" prop="password">
            <el-input
              v-model="form.password"
              show-password
              @keyup.native.enter="submitForm"
            ></el-input>
          </el-form-item>
          <el-button
            :loading="loading"
            type="primary"
            class="login-in"
            @click="submitForm"
            >登录</el-button
          >
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import API from "@/api";
import local from "@/utils/localStroage.js";
export default {
  name: "login",
  data() {
    return {
      form: {
        name: "",
        passWord: "",
      },
      QRcode: "",
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        passWord: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      checked: false,
      loading: false,
    };
  },
  created() {
    // 从localStroage读取用户登录信息，存在则自动填充密码
    let loginInfo = local.get("loginInfo");
    if (loginInfo) {
      this.checked = true;
      this.form = loginInfo;
    }
  },
  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          this.login();
        } else {
          return false;
        }
      });
    },
    // 登录保存登录状态到本地存储器
    login() {
      let params = Object.assign({}, this.form);
      try {
        API.login(params)
          .then((res) => {
            if (res.code === 200) {
              // 保存用户信息
              local.set("token", res.data.token);
              this.$router.push({
                path: "/application",
              });
            } else {
              this.$message.error("账号或密码错误，请重新登陆");
            }
          })
          .catch((err) => {
            this.$message.error(err);
          });
      } catch (err) {
        this.$message.error(err);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.login-main {
  width: 100%;
  height: 100%;
  background: #0e0d1f;
  background-size: 100% 100%;
  overflow: hidden;
  position: relative;
  .black-bg-box {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .title {
    color: white;
    font-size: 52px;
    font-weight: bold;
    text-align: center;
    margin-top: 150px;
    letter-spacing: 5px;
  }
  .login-form-box {
    width: 400px;
    height: 330px;
    background: rgba(255, 255, 255, 1);
    margin: 0 auto;
    border-radius: 5px;
    margin-top: 80px;
    padding-top: 20px;
  }
  p {
    color: #333;
    text-align: center;
    font-size: 35px;
  }
  .login-from {
    // text-align: center;
    margin-top: 20px;
    .el-input {
      width: 300px;
    }
    .password {
      margin-bottom: 0px;
    }
    .el-checkbox {
      font-weight: normal;
    }
    .login-in {
      width: 75%;
      margin-top: 40px;
      margin-left: 15%;
    }
  }
}
</style>
